
export function translationsFetcher(language: string, ns: string) {
  const isDefaultNamespace = ns && ns === 'translation'
  if (isDefaultNamespace) return import(`../../locales/${language}.json`)
  return import(`../../locales/${language}/${ns}.json`)
}